export default __webpack_public_path__ + "media/images/planning-2-7eb6c8f946b40e15600406b3f235089d.svg";